module.exports = __webpack_public_path__ + "img/vita_photo.23386903.png";